// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"870547cb","280":"5fa3ab28","453":"0e865618"}[chunkId] + ".chunk.js";
};